import ArticleCard from "@components/Blocks/Card/Article/ArticleCard";
import { ProcessedArticleData } from "@hooks/transformer/useOSResponse";

import { LayoutSlot } from "./layout";

export function renderSlot(
  slot: LayoutSlot,
  articles: ProcessedArticleData[],
  uniqueKeyPrefix: string,
) {
  const article = articles.at(slot.index);
  if (!article) return null;

  return (
    <div
      key={`${uniqueKeyPrefix}-${article.id}`}
      className={slot.className}
      data-testid="article-slot"
    >
      <ArticleCard
        key={`${uniqueKeyPrefix}-card-${article.id}`}
        {...article}
        orientation={slot.orientation ?? "vertical"}
        variant="xxl"
        displayWidth={slot.imgWidth ?? 360}
        displayHeight={slot.imgHeight ?? 270}
        forNewDesign
      />
    </div>
  );
}
